// extracted by mini-css-extract-plugin
export default {"container":"editPermissionGroup_container__ov7Ae","errorMessage":"editPermissionGroup_errorMessage__98FZS"};